import React, { useEffect, useState } from 'react';
import Heading from '../../common/Heading/Heading';
import {
  App,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Row,
  Select,
  Spin,
  Input,
  Checkbox,
} from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import {
  addLeaveAllocation,
  getLeaveAllocationDetails,
  updateLeaveAllocation,
} from '../../../network/leaveAllocation';
import dayjs from 'dayjs';
import { getSearchApi } from '../../../network/itemList';
import { getEmployee, getEmployeeDetails } from '../../../network/employee';
import {
  addEmployeeAdvance,
  getEmployeeAdvanceDetails,
  updateEmployeeAdvance,
} from '../../../network/employeeAdvance';
import {
  addAdditionalSalay,
  getAdditionalSalayDetails,
  updateAdditionalSalay,
} from '../../../network/additionalSalay';
import { getSalaryDeduction } from '../../../network/employeeAdvance';
import { submitMaterialRequest } from '../../../network/materialRequest';
import HeadingApp from '../../../hooks/HeadingApp';
import { FaMoneyBillTrendUp } from 'react-icons/fa6';
const AddAdditionalSalay = ({ t, edit, employee }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { id, idSalary } = useParams();
  const { companyName } = useSelector((state) => state.user);
  const client = useQueryClient();
  const { message } = App.useApp();
  const [loadingAdd, setLoadingAdd] = useState(false);
  const [selectName, setSelectName] = useState(null);
  const [dataStatus, setDataStatus] = useState(null);
  const [submitButton, setSubmitButton] = useState(false);
  const { mutate: onAddAdditionalSalay } = useMutation({
    mutationKey: ['addAdditionalSalay'],
    mutationFn: (body) =>
      edit ? updateAdditionalSalay(body, id) : addAdditionalSalay(body),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data?.message, 'datawwww');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(
        data?.message?.message ? data?.message?.message : 'Added successfully'
      );
      setSelectName(edit ? id : data?.data?.name);
      setSubmitButton(true);
      client.invalidateQueries({ queryKey: [queryKeys.getAdditionalSalay] });
      // form.resetFields();
      edit && dataStatus !== 0 && navigate('/additional-salay');
    },
    onError: (error) => {
      setLoadingAdd(false);
      // message.error(error.response.data._server_messages);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
      console.log('error:', error);
    },
  });
  const handleSubmit = useMutation({
    mutationFn: (id) => submitMaterialRequest('Additional Salary', id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message || 'Submitted successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getAdditionalSalay] });
      navigate('/additional-salay');
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const watchIsRecurring = Form.useWatch('is_recurring', form);
  const { data: additionalSalayDetails, isLoading } = useQuery({
    queryKey: [queryKeys.getAdditionalSalay, id],
    queryFn: () => getAdditionalSalayDetails(id),
    enabled: !!edit,
  });
  const { mutate: onGetEmployee } = useMutation({
    mutationKey: [queryKeys.getEmployeeDetails],
    mutationFn: (value) => getEmployeeDetails(value),
    onSuccess: (data) => {
      console.log(data, 'data');
      form.setFieldsValue({
        employee_name: data?.data?.employee_name,
        department: data?.data?.department,
      });
    },
  });
  const { data: employeeAdvanceDetails, isLoading: isLoadingEmployee } =
    useQuery({
      queryKey: [queryKeys.getSalaryDeduction, idSalary],
      queryFn: () => getSalaryDeduction(idSalary),
      enabled: !!employee,
    });
  const { data: employeeData } = useQuery({
    queryKey: [queryKeys.getEmployee],
    queryFn: () => getEmployee(),
  });
  // console.log(employee, 'employee');

  const { data: salaryComponent } = useQuery({
    queryKey: [queryKeys.getSearchApiSalaryComponent],
    queryFn: () => getSearchApi('Salary+Component'),
    keepPreviousData: true,
  });
  const onFinish = (values) => {
    setLoadingAdd(true);
    onAddAdditionalSalay({
      ...values,
      company: companyName,
      currency: 'SAR',
      payroll_date: dayjs(values?.payroll_date).format('YYYY-MM-DD'),
      from_date: dayjs(values?.from_date).format('YYYY-MM-DD'),
      to_date: dayjs(values?.to_date).format('YYYY-MM-DD'),
      amount: Number(values?.amount),
      exchange_rate: 1.0,
      overwrite_salary_structure_amount:
        values?.overwrite_salary_structure_amount ? 1 : 0,
      is_recurring: values?.is_recurring ? 1 : 0,
      disabled: values?.disabled ? 1 : 0,
    });
  };
  useEffect(() => {
    if (employee && employeeAdvanceDetails) {
      onGetEmployee(employeeAdvanceDetails?.message?.employee);
      form.setFieldsValue({
        ...employeeAdvanceDetails?.message,
        payroll_date: dayjs(employeeAdvanceDetails?.message?.payroll_date),
        from_date: dayjs(employeeAdvanceDetails?.message?.from_date),
        to_date: dayjs(employeeAdvanceDetails?.message?.to_date),
      });
    }
  }, [employee, employeeAdvanceDetails, form]);
  useEffect(() => {
    if (edit && additionalSalayDetails) {
      setDataStatus(additionalSalayDetails?.data?.docstatus);
      form.setFieldsValue({
        ...additionalSalayDetails?.data,
        payroll_date: dayjs(additionalSalayDetails?.data?.payroll_date),
        from_date: dayjs(additionalSalayDetails?.data?.from_date),
        to_date: dayjs(additionalSalayDetails?.data?.to_date),
      });
    }
  }, [edit, additionalSalayDetails, form]);
  if (isLoading || isLoadingEmployee) {
    return (
      <div
        style={{
          width: '100%',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }
  return (
    <>
      {/* <Heading
        title={t.HR}
        subTitle={edit ? t.EditAdditionalSalay : t.AddAdditionalSalay}
        path="/additional-salay"
      /> */}
      <HeadingApp
        nameTab={t.HR}
        title={t.AdditionalSalay}
        subTitle={edit ? t.EditAdditionalSalay : t.AddAdditionalSalay}
        icon={<FaMoneyBillTrendUp />}
      />
      <Card style={{ borderRadius: '0px' }}>
        <Form
          form={form}
          name="add-additional-salay"
          layout="vertical"
          onFinish={onFinish}
          style={{ marginTop: '20px' }}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} md={24} lg={18}>
              <Row gutter={[16, 0]}>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="employee"
                    label={t.Employee}
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder={t.Employee}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLocaleLowerCase()
                          .includes(input)
                      }
                      onChange={(value, option) => {
                        console.log(option, 'option');
                        form.setFieldsValue({
                          employee_name: option?.option?.employee_name,
                          department: option?.option?.department,
                        });
                      }}
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      options={employeeData?.data?.map((user) => ({
                        value: user.name,
                        label: user.name,
                        option: user,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="employee_name"
                    label={t.employeeName}
                    // rules={[{ required: true }]}
                  >
                    <Input placeholder={t.employeeName} disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item name="department" label={t.department}>
                    <Input placeholder={t.department} disabled />
                  </Form.Item>
                </Col>
                <Col xs={12} md={12} xl={8} xxl={8}>
                  <Form.Item name="is_recurring" valuePropName="checked">
                    <Checkbox>{t.isRecurring}</Checkbox>
                  </Form.Item>
                </Col>
                <Col xs={12} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="overwrite_salary_structure_amount"
                    valuePropName="checked"
                  >
                    <Checkbox>{t.overwriteSalaryStructureAmount}</Checkbox>
                  </Form.Item>
                </Col>
                <Col xs={12} md={12} xl={8} xxl={8}>
                  <Form.Item name="disabled" valuePropName="checked">
                    <Checkbox>{t.disabled}</Checkbox>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="salary_component"
                    label={t.salaryComponent}
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder={t.salaryComponent}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLocaleLowerCase()
                          .includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      options={salaryComponent?.message?.map((user) => ({
                        value: user.value,
                        label: user.value,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item name="amount" label={t.amount}>
                    <Input type="number" min={0} placeholder={t.amount} />
                  </Form.Item>
                </Col>

                {watchIsRecurring ? (
                  <>
                    <Col xs={24} md={12} xl={8} xxl={8}>
                      <Form.Item
                        name="from_date"
                        label={t.fromDate}
                        rules={[{ required: true }]}
                        initialValue={dayjs()}
                      >
                        <DatePicker
                          placeholder={t.fromDate}
                          format="YYYY-MM-DD"
                          style={{ width: '100%' }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12} xl={8} xxl={8}>
                      <Form.Item
                        name="to_date"
                        label={t.ToDate}
                        rules={[{ required: true }]}
                        initialValue={dayjs()}
                      >
                        <DatePicker
                          placeholder={t.ToDate}
                          format="YYYY-MM-DD"
                          style={{ width: '100%' }}
                        />
                      </Form.Item>
                    </Col>
                  </>
                ) : (
                  <Col xs={24} md={12} xl={8} xxl={8}>
                    <Form.Item
                      name="payroll_date"
                      label={t.payrollDate}
                      rules={[{ required: true }]}
                      initialValue={dayjs()}
                    >
                      <DatePicker
                        placeholder={t.payrollDate}
                        format="YYYY-MM-DD"
                        style={{ width: '100%' }}
                        // disabled={employee ? false : !watchIsRecurring}
                      />
                    </Form.Item>
                  </Col>
                )}
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item name="type" label={t.type} hidden={!edit}>
                    <Input placeholder={t.type} disabled />
                  </Form.Item>
                </Col>
              </Row>
              <div className="form-btns">
                <Button type="primary" ghost onClick={() => navigate(-1)}>
                  {t.cancel}
                </Button>
                <Button
                  type="primary"
                  onClick={() => {
                    if (submitButton) {
                      setLoadingAdd(true);
                      handleSubmit.mutate(selectName);
                    } else {
                      form.submit();
                    }
                  }}
                  loading={loadingAdd}
                >
                  {submitButton ? t.submit : edit ? t.edit : t.Save}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Card>
    </>
  );
};

export default AddAdditionalSalay;
